import { css } from "../../../styled-system/css";

export const styles = {
  section: () =>
    css({
      width: "100%",
      margin: "0 auto",
      tabletLandscape: {
        maxWidth: "950px",
      },
      desktop: {
        maxWidth: "maxContentWidth",
      },
    }),
  wrapper: () =>
    css({
      display: "flex",
      flexDirection: "column",
      gap: "baseUnit.mobile3",
      tabletLandscape: {
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: "baseUnit.mobile3",
      },
      desktop: {
        paddingLeft: "baseUnit.mobile16",
        paddingRight: "baseUnit.mobile4",
      },
    }),
  textColumn: () =>
    css({
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      gap: "baseUnit.mobile2",
      paddingX: "baseUnit.mobile4",
      tabletLandscape: {
        alignItems: "flex-start",
        gap: "baseUnit.mobile3",
        paddingX: 0,
      },
    }),
  headline: () =>
    css({
      margin: 0,
      color: "midnight",
      fontWeight: 800,
      fontSize: "heading.H2.mobile",
      lineHeight: "heading.H2.mobile",
      letterSpacing: "heading.H2.mobile",
      tabletLandscape: {
        fontSize: "heading.H1.desktop",
        lineHeight: "heading.H1.desktop",
        letterSpacing: "heading.H1.desktop",
      },
    }),
  featureList: () =>
    css({
      listStyle: "none",
      margin: 0,
      padding: 0,
      display: "flex",
      flexDirection: "column",
      width: "100%",
    }),
  hiddenFeatureList: () =>
    css({
      paddingTop: "baseUnit.mobile2",
    }),
  action: () =>
    css({
      width: "100%",
      marginTop: "baseUnit.mobile2",
      tabletLandscape: {
        width: "auto",
      },
    }),
  chevron: () =>
    css({
      display: "inline-flex",
      transition: "transform 0.3s ease",
      "@media (prefers-reduced-motion: reduce)": {
        transition: "none",
      },
    }),
  chevronExpanded: () =>
    css({
      transform: "rotate(180deg)",
    }),
  hiddenList: () =>
    css({
      width: "100%",
      overflow: "hidden",
      maxHeight: 0,
      transition: "max-height 0.4s ease",
      "@media (prefers-reduced-motion: reduce)": {
        transition: "none",
      },
    }),
  illustrationMobile: () =>
    css({
      width: "100%",
      tabletLandscape: {
        display: "none",
      },
    }),
  illustrationDesktop: () =>
    css({
      display: "none",
      tabletLandscape: {
        display: "block",
        flexShrink: 0,
        width: "100%",
        maxWidth: "450px",
        marginTop: "baseUnit.mobile5",
      },
      desktop: {
        maxWidth: "530px",
      },
    }),
};
